import React from "react";
import PropTypes from "prop-types";

const SvgIcon = ({ name, size = 24, color = "currentColor" }) => {
  switch (name) {
    case "edit":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5026 17.499H10.836M2.08594 17.9156L6.71033 16.137C7.00611 16.0232 7.154 15.9664 7.29237 15.8921C7.41527 15.8261 7.53244 15.75 7.64264 15.6645C7.7667 15.5682 7.87875 15.4561 8.10284 15.2321L17.5026 5.83228C18.4231 4.91181 18.4231 3.41943 17.5026 2.49895C16.5822 1.57848 15.0898 1.57847 14.1693 2.49895L4.76951 11.8987C4.54542 12.1228 4.43337 12.2348 4.3371 12.3589C4.25158 12.4691 4.17544 12.5863 4.10947 12.7092C4.03519 12.8476 3.97831 12.9954 3.86455 13.2912L2.08594 17.9156ZM2.08594 17.9156L3.80104 13.4564C3.92377 13.1373 3.98513 12.9778 4.09039 12.9047C4.18237 12.8408 4.29619 12.8167 4.40618 12.8377C4.53205 12.8617 4.65292 12.9826 4.89467 13.2243L6.77725 15.1069C7.019 15.3487 7.13987 15.4695 7.16391 15.5954C7.18491 15.7054 7.16076 15.8192 7.09689 15.9112C7.02381 16.0164 6.86426 16.0778 6.54516 16.2005L2.08594 17.9156Z"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );

    case "view":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.01677 10.5937C1.90328 10.414 1.84654 10.3241 1.81477 10.1855C1.79091 10.0814 1.79091 9.91727 1.81477 9.81317C1.84654 9.67458 1.90328 9.58473 2.01677 9.40503C2.95461 7.92005 5.74617 4.16602 10.0003 4.16602C14.2545 4.16602 17.0461 7.92005 17.9839 9.40503C18.0974 9.58473 18.1541 9.67458 18.1859 9.81317C18.2098 9.91727 18.2098 10.0814 18.1859 10.1855C18.1541 10.3241 18.0974 10.414 17.9839 10.5937C17.0461 12.0786 14.2545 15.8327 10.0003 15.8327C5.74617 15.8327 2.95461 12.0786 2.01677 10.5937Z"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M10.0003 12.4993C11.381 12.4993 12.5003 11.3801 12.5003 9.99935C12.5003 8.61864 11.381 7.49935 10.0003 7.49935C8.61962 7.49935 7.50034 8.61864 7.50034 9.99935C7.50034 11.3801 8.61962 12.4993 10.0003 12.4993Z"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case "menu":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 12H21M3 6H21M3 18H21" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "copy":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );

    case "tools":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "view-off":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "add":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.9974 4.16602V15.8327M4.16406 9.99935H15.8307"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );

    case "arrow-down":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrow-left":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 12H5M5 12L12 19M5 12L12 5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrow-right":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 12H20M20 12L14 6M20 12L14 18"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "chevron-left":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "chevron-right":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrow-up":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 15L12 9L6 15"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "delete":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 5H4.16667H17.5"
            strokeWidth="1.33333"
            strokeLinecap="round"
          />
          <path
            d="M15.8307 5.0013V16.668C15.8307 17.11 15.6551 17.5339 15.3426 17.8465C15.03 18.159 14.6061 18.3346 14.1641 18.3346H5.83073C5.3887 18.3346 4.96478 18.159 4.65222 17.8465C4.33966 17.5339 4.16406 17.11 4.16406 16.668V5.0013M6.66406 5.0013V3.33464C6.66406 2.89261 6.83966 2.46868 7.15222 2.15612C7.46478 1.84356 7.8887 1.66797 8.33073 1.66797H11.6641C12.1061 1.66797 12.53 1.84356 12.8426 2.15612C13.1551 2.46868 13.3307 2.89261 13.3307 3.33464V5.0013"
            strokeWidth="1.33333"
            strokeLinecap="round"
          />
          <path
            d="M8.33594 9.16797V14.168"
            strokeWidth="1.33333"
            strokeLinecap="round"
          />
          <path
            d="M11.6641 9.16797V14.168"
            strokeWidth="1.33333"
            strokeLinecap="round"
          />
        </svg>
      );

    case "filter":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.25 12H18.25M3.25 6H21.25M9.25 18H15.25"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "search":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.25 21L17.7501 17.5M20.25 11.5C20.25 16.1944 16.4444 20 11.75 20C7.05558 20 3.25 16.1944 3.25 11.5C3.25 6.80558 7.05558 3 11.75 3C16.4444 3 20.25 6.80558 20.25 11.5Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "reorder":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.25 4V20M7.25 20L3.25 16M7.25 20L11.25 16M17.25 20V4M17.25 4L13.25 8M17.25 4L21.25 8"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "close":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path d="M6.3975 18.6532L5.34375 17.5995L10.9437 11.9995L5.34375 6.39945L6.3975 5.3457L11.9975 10.9457L17.5975 5.3457L18.6513 6.39945L13.0513 11.9995L18.6513 17.5995L17.5975 18.6532L11.9975 13.0532L6.3975 18.6532Z" />
        </svg>
      );

    case "calendar":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );

    case "class":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 15.75L8.92496 15.6374C8.40398 14.856 8.14349 14.4652 7.79933 14.1824C7.49464 13.9319 7.14357 13.7441 6.7662 13.6295C6.33994 13.5 5.87033 13.5 4.93112 13.5H3.9C3.05992 13.5 2.63988 13.5 2.31901 13.3365C2.03677 13.1927 1.8073 12.9632 1.66349 12.681C1.5 12.3601 1.5 11.9401 1.5 11.1V4.65C1.5 3.80992 1.5 3.38988 1.66349 3.06901C1.8073 2.78677 2.03677 2.5573 2.31901 2.41349C2.63988 2.25 3.05992 2.25 3.9 2.25H4.2C5.88016 2.25 6.72024 2.25 7.36197 2.57698C7.92646 2.8646 8.3854 3.32354 8.67302 3.88803C9 4.52976 9 5.36984 9 7.05M9 15.75V7.05M9 15.75L9.07504 15.6374C9.59602 14.856 9.85651 14.4652 10.2007 14.1824C10.5054 13.9319 10.8564 13.7441 11.2338 13.6295C11.6601 13.5 12.1297 13.5 13.0689 13.5H14.1C14.9401 13.5 15.3601 13.5 15.681 13.3365C15.9632 13.1927 16.1927 12.9632 16.3365 12.681C16.5 12.3601 16.5 11.9401 16.5 11.1V4.65C16.5 3.80992 16.5 3.38988 16.3365 3.06901C16.1927 2.78677 15.9632 2.5573 15.681 2.41349C15.3601 2.25 14.9401 2.25 14.1 2.25H13.8C12.1198 2.25 11.2798 2.25 10.638 2.57698C10.0735 2.8646 9.6146 3.32354 9.32698 3.88803C9 4.52976 9 5.36984 9 7.05"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case "clients":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "attend":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 11L12 14L22 4M16 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );

    case "settings":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M14.0455 11.0455C13.9547 11.2511 13.9276 11.4792 13.9677 11.7004C14.0078 11.9216 14.1133 12.1257 14.2705 12.2864L14.3114 12.3273C14.4382 12.4539 14.5387 12.6043 14.6074 12.7699C14.676 12.9354 14.7113 13.1128 14.7113 13.292C14.7113 13.4712 14.676 13.6487 14.6074 13.8142C14.5387 13.9798 14.4382 14.1302 14.3114 14.2568C14.1847 14.3836 14.0343 14.4842 13.8688 14.5528C13.7032 14.6214 13.5258 14.6568 13.3466 14.6568C13.1674 14.6568 12.9899 14.6214 12.8244 14.5528C12.6589 14.4842 12.5085 14.3836 12.3818 14.2568L12.3409 14.2159C12.1802 14.0587 11.9761 13.9533 11.7549 13.9132C11.5338 13.8731 11.3056 13.9001 11.1 13.9909C10.8983 14.0773 10.7264 14.2208 10.6052 14.4038C10.4841 14.5867 10.4191 14.8011 10.4182 15.0205V15.1364C10.4182 15.498 10.2745 15.8449 10.0188 16.1006C9.76305 16.3563 9.4162 16.5 9.05455 16.5C8.69289 16.5 8.34604 16.3563 8.09031 16.1006C7.83458 15.8449 7.69091 15.498 7.69091 15.1364V15.075C7.68563 14.8493 7.61258 14.6305 7.48126 14.4468C7.34993 14.2632 7.16641 14.1234 6.95455 14.0455C6.7489 13.9547 6.52078 13.9276 6.2996 13.9677C6.07842 14.0078 5.87433 14.1133 5.71364 14.2705L5.67273 14.3114C5.54608 14.4382 5.39569 14.5387 5.23015 14.6074C5.0646 14.676 4.88716 14.7113 4.70795 14.7113C4.52875 14.7113 4.35131 14.676 4.18576 14.6074C4.02022 14.5387 3.86983 14.4382 3.74318 14.3114C3.6164 14.1847 3.51582 14.0343 3.44719 13.8688C3.37857 13.7032 3.34325 13.5258 3.34325 13.3466C3.34325 13.1674 3.37857 12.9899 3.44719 12.8244C3.51582 12.6589 3.6164 12.5085 3.74318 12.3818L3.78409 12.3409C3.94128 12.1802 4.04672 11.9761 4.08682 11.7549C4.12693 11.5338 4.09985 11.3056 4.00909 11.1C3.92266 10.8983 3.77915 10.7264 3.59623 10.6052C3.4133 10.4841 3.19895 10.4191 2.97955 10.4182H2.86364C2.50198 10.4182 2.15513 10.2745 1.8994 10.0188C1.64367 9.76305 1.5 9.4162 1.5 9.05455C1.5 8.69289 1.64367 8.34604 1.8994 8.09031C2.15513 7.83458 2.50198 7.69091 2.86364 7.69091H2.925C3.15068 7.68563 3.36955 7.61258 3.55316 7.48126C3.73677 7.34993 3.87662 7.16641 3.95455 6.95455C4.04531 6.7489 4.07238 6.52078 4.03228 6.2996C3.99217 6.07842 3.88673 5.87433 3.72955 5.71364L3.68864 5.67273C3.56185 5.54608 3.46127 5.39569 3.39265 5.23015C3.32402 5.0646 3.2887 4.88716 3.2887 4.70795C3.2887 4.52875 3.32402 4.35131 3.39265 4.18576C3.46127 4.02022 3.56185 3.86983 3.68864 3.74318C3.81528 3.6164 3.96568 3.51582 4.13122 3.44719C4.29676 3.37857 4.47421 3.34325 4.65341 3.34325C4.83261 3.34325 5.01006 3.37857 5.1756 3.44719C5.34114 3.51582 5.49154 3.6164 5.61818 3.74318L5.65909 3.78409C5.81978 3.94128 6.02387 4.04672 6.24505 4.08682C6.46623 4.12693 6.69435 4.09985 6.9 4.00909H6.95455C7.15621 3.92266 7.32819 3.77915 7.44934 3.59623C7.57048 3.4133 7.63549 3.19895 7.63636 2.97955V2.86364C7.63636 2.50198 7.78003 2.15513 8.03576 1.8994C8.2915 1.64367 8.63834 1.5 9 1.5C9.36166 1.5 9.7085 1.64367 9.96424 1.8994C10.22 2.15513 10.3636 2.50198 10.3636 2.86364V2.925C10.3645 3.1444 10.4295 3.35876 10.5507 3.54168C10.6718 3.72461 10.8438 3.86812 11.0455 3.95455C11.2511 4.04531 11.4792 4.07238 11.7004 4.03228C11.9216 3.99217 12.1257 3.88673 12.2864 3.72955L12.3273 3.68864C12.4539 3.56185 12.6043 3.46127 12.7699 3.39265C12.9354 3.32402 13.1128 3.2887 13.292 3.2887C13.4712 3.2887 13.6487 3.32402 13.8142 3.39265C13.9798 3.46127 14.1302 3.56185 14.2568 3.68864C14.3836 3.81528 14.4842 3.96568 14.5528 4.13122C14.6214 4.29676 14.6568 4.47421 14.6568 4.65341C14.6568 4.83261 14.6214 5.01006 14.5528 5.1756C14.4842 5.34114 14.3836 5.49154 14.2568 5.61818L14.2159 5.65909C14.0587 5.81978 13.9533 6.02387 13.9132 6.24505C13.8731 6.46623 13.9001 6.69435 13.9909 6.9V6.95455C14.0773 7.15621 14.2208 7.32819 14.4038 7.44934C14.5867 7.57048 14.8011 7.63549 15.0205 7.63636H15.1364C15.498 7.63636 15.8449 7.78003 16.1006 8.03576C16.3563 8.2915 16.5 8.63834 16.5 9C16.5 9.36166 16.3563 9.7085 16.1006 9.96424C15.8449 10.22 15.498 10.3636 15.1364 10.3636H15.075C14.8556 10.3645 14.6412 10.4295 14.4583 10.5507C14.2754 10.6718 14.1319 10.8438 14.0455 11.0455Z"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
        </svg>
      );

    case "category":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.25 9H15.75M2.25 4.5H15.75M2.25 13.5H15.75"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "session":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "map-pin":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 9.75C10.2426 9.75 11.25 8.74264 11.25 7.5C11.25 6.25736 10.2426 5.25 9 5.25C7.75736 5.25 6.75 6.25736 6.75 7.5C6.75 8.74264 7.75736 9.75 9 9.75Z"
            strokeOpacity="0.65"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 16.5C12 13.5 15 10.8137 15 7.5C15 4.18629 12.3137 1.5 9 1.5C5.68629 1.5 3 4.18629 3 7.5C3 10.8137 6 13.5 9 16.5Z"
            strokeOpacity="0.65"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "lead":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4987 11.8777C14.5906 12.4262 15.5268 13.3065 16.2101 14.4072C16.3454 14.6252 16.4131 14.7342 16.4365 14.8851C16.484 15.1918 16.2743 15.5689 15.9886 15.6903C15.848 15.75 15.6899 15.75 15.3737 15.75M11.9987 8.64918C13.1099 8.09692 13.8737 6.95015 13.8737 5.625C13.8737 4.29985 13.1099 3.15308 11.9987 2.60082M10.4987 5.625C10.4987 7.48896 8.98762 9 7.12366 9C5.2597 9 3.74866 7.48896 3.74866 5.625C3.74866 3.76104 5.2597 2.25 7.12366 2.25C8.98762 2.25 10.4987 3.76104 10.4987 5.625ZM1.91808 14.2038C3.11381 12.4084 5.00069 11.25 7.12366 11.25C9.24663 11.25 11.1335 12.4084 12.3292 14.2038C12.5912 14.5971 12.7222 14.7937 12.7071 15.0449C12.6953 15.2405 12.5671 15.48 12.4108 15.5982C12.2101 15.75 11.934 15.75 11.3819 15.75H2.86542C2.31329 15.75 2.03722 15.75 1.83649 15.5982C1.68019 15.48 1.55197 15.2405 1.54023 15.0449C1.52515 14.7937 1.65613 14.5971 1.91808 14.2038Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "form":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 17H6.5M17.5 13H6.5M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "instructor":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "package":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.30769 3H3C2.44772 3 2 3.44771 2 4V13C2 13.5523 2.44772 14 3 14H15C15.5523 14 16 13.5523 16 13V4C16 3.44772 15.5523 3 15 3H11.6923M6.30769 3V7.95H11.6923V3M6.30769 3H11.6923"
            strokeWidth="1.5"
          />
        </svg>
      );

    case "rooms":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 1.70215V4.80005C10.5 5.22009 10.5 5.43011 10.5817 5.59055C10.6537 5.73167 10.7684 5.8464 10.9095 5.91831C11.0699 6.00005 11.28 6.00005 11.7 6.00005H14.7979M12 9.75H6M12 12.75H6M7.5 6.75H6M10.5 1.5H6.6C5.33988 1.5 4.70982 1.5 4.22852 1.74524C3.80516 1.96095 3.46095 2.30516 3.24524 2.72852C3 3.20982 3 3.83988 3 5.1V12.9C3 14.1601 3 14.7902 3.24524 15.2715C3.46095 15.6948 3.80516 16.039 4.22852 16.2548C4.70982 16.5 5.33988 16.5 6.6 16.5H11.4C12.6601 16.5 13.2902 16.5 13.7715 16.2548C14.1948 16.039 14.539 15.6948 14.7548 15.2715C15 14.7902 15 14.1601 15 12.9V6L10.5 1.5Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "location":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 9C15 12.3137 12.3137 15 9 15M15 9C15 5.68629 12.3137 3 9 3M15 9H16.5M9 15C5.68629 15 3 12.3137 3 9M9 15V16.5M3 9C3 5.68629 5.68629 3 9 3M3 9H1.5M9 3V1.5M11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "logout":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 18 18"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75M9 12.75C9 13.4475 9 13.7962 8.92333 14.0823C8.71528 14.8588 8.1088 15.4653 7.33234 15.6733C7.04622 15.75 6.69748 15.75 6 15.75H5.625C4.57663 15.75 4.05245 15.75 3.63896 15.5787C3.08765 15.3504 2.64963 14.9124 2.42127 14.361C2.25 13.9476 2.25 13.4234 2.25 12.375V5.625C2.25 4.57663 2.25 4.05245 2.42127 3.63896C2.64963 3.08765 3.08765 2.64963 3.63896 2.42127C4.05245 2.25 4.57663 2.25 5.625 2.25H6C6.69748 2.25 7.04622 2.25 7.33234 2.32667C8.1088 2.53472 8.71528 3.1412 8.92333 3.91766C9 4.20378 9 4.55252 9 5.25"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );

    case "dots":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "save":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.66667 2V4.26667C4.66667 4.64004 4.66667 4.82672 4.73933 4.96933C4.80324 5.09477 4.90523 5.19676 5.03067 5.26067C5.17328 5.33333 5.35997 5.33333 5.73333 5.33333H10.2667C10.64 5.33333 10.8267 5.33333 10.9693 5.26067C11.0948 5.19676 11.1968 5.09477 11.2607 4.96933C11.3333 4.82672 11.3333 4.64004 11.3333 4.26667V2.66667M11.3333 14V9.73333C11.3333 9.35997 11.3333 9.17328 11.2607 9.03067C11.1968 8.90523 11.0948 8.80324 10.9693 8.73933C10.8267 8.66667 10.64 8.66667 10.2667 8.66667H5.73333C5.35997 8.66667 5.17328 8.66667 5.03067 8.73933C4.90523 8.80324 4.80324 8.90523 4.73933 9.03067C4.66667 9.17328 4.66667 9.35997 4.66667 9.73333V14M14 6.21699V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H9.78301C10.1091 2 10.2722 2 10.4256 2.03684C10.5617 2.0695 10.6918 2.12337 10.811 2.19648C10.9456 2.27894 11.0609 2.39424 11.2915 2.62484L13.3752 4.7085C13.6058 4.9391 13.7211 5.0544 13.8035 5.18895C13.8766 5.30825 13.9305 5.43831 13.9632 5.57436C14 5.72781 14 5.89087 14 6.21699Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "image":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2 21H6.93137C6.32555 21 6.02265 21 5.88238 20.8802C5.76068 20.7763 5.69609 20.6203 5.70865 20.4608C5.72312 20.2769 5.93731 20.0627 6.36569 19.6343L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21 15V16.2M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "add-image":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "upload":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "input":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "dropdown":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "textarea":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "at-sign":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 7.99999V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2043 16 19 16C19.7956 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74302 21.2362 7.55247 19.8333 5.78452C18.4303 4.01658 16.4705 2.77521 14.2726 2.26229C12.0747 1.74936 9.76793 1.99503 7.72734 2.95936C5.68676 3.92368 4.03239 5.54995 3.03325 7.57371C2.03411 9.59748 1.74896 11.8997 2.22416 14.1061C2.69936 16.3125 3.90697 18.2932 5.65062 19.7263C7.39428 21.1593 9.57143 21.9603 11.8281 21.9991C14.0847 22.0379 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79085 9.79086 7.99999 12 7.99999C14.2091 7.99999 16 9.79085 16 12Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "checkbox":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "check":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 6L9 17L4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "radio":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      );
    case "download":
      return (
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className="feather feather-download">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
      );
    case "transfer":
      return (
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width={size} 
          height={size} 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke={color} 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          className="feather feather-repeat"
        >
          <polyline points="17 1 21 5 17 9"></polyline>
          <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
          <polyline points="7 23 3 19 7 15"></polyline>
          <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
        </svg>
      );
      case "resend":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      );
      case "transaction":
        return (
          <svg 
            fill={color || "#000000"} 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path d="M11,23.4L1.3,17l9.7-6.4V14h13v6H11V23.4z M4.7,17L9,19.9V18h13v-2H9v-1.9L4.7,17z M13,13.4V10H0V4h13V0.6L22.7,7L13,13.4z M2,8h13v1.9L19.3,7L15,4.2V6H2V8z"/>
            </g>
          </svg>
        );
        case "marketing":
          return (
            <svg 
              width={size}
              height={size}
              viewBox="0 0 256 256"
              fill="none"
              stroke={color || "#000000"}
              strokeWidth="16"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="4"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M 48.000002,16 H 208 c 17.728,0 32,14.272 32,32 v 160 c 0,17.728 -14.272,32 -32,32 H 48.000002 c -17.728,0 -32,-14.272 -32,-32 V 48 c 0,-17.728 14.272,-32 32,-32 z" />
                <path d="M 64.000006,64.000001 H 79.999993" />
                <path transform="rotate(90)" d="m 79.999996,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z" />
                <path d="m 112.00001,64.000353 79.99997,-3.52e-4" />
                <path d="M 191.99998,128 H 176" />
                <path transform="matrix(0,1,1,0,0,0)" d="m 144,159.99997 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16 16,16 0 0 1 16,16 z" />
                <path d="M 143.99998,128.00035 64.000006,128" />
                <path d="M 64.000006,192.00001 H 79.999993" />
                <path transform="rotate(90)" d="m 208,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z" />
                <path d="m 112.00001,192.00036 79.99997,-3.5e-4" />
              </g>
            </svg>
          );
    case "payment":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 75.376 75.376"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M56.206,47.937c-0.069-0.408-0.524-0.697-0.929-0.455c-0.819,0.488-1.726,0.609-2.531,1.232 c-0.977,0.754-1.364,2.299-1.304,3.465c0.12,2.316,2.21,3.65,4.347,3.748c2.482,0.113,4.63-1.885,4.614-4.361 C60.388,49.298,58.227,48.204,56.206,47.937z M57.919,51.855c-0.287,1.189-1.758,1.455-2.736,1.174 c-0.989-0.283-0.881-1.154-0.663-1.951c0.117-0.43,0.649-0.816,0.928-1.145c0.001-0.002,0.001-0.002,0.003-0.002 C56.575,50.042,58.244,50.505,57.919,51.855z"/>
            <path d="M68.884,39.841c0.212-4.092,0.554-8.678-2.784-11.441c-1.114-0.922-2.526-1.232-3.954-1.357 c0.928-1.293,1.649-2.836,2.619-4.057c1.16-1.459,3.639-4.16,2.042-6.311c-0.646-0.869-1.858-1.016-2.562-1.859 c-1.362-1.631-3.108-2.865-4.687-4.248c-3.776-3.313-7.571-6.332-11.986-8.608c-2.482-1.279-5.606-3.082-8.167-1.031 c-3.254,2.607-5.295,6.592-7.631,10.059c-3.073,4.561-6.204,9.047-9.711,13.24c-0.817,0.981-1.923,2.178-2.956,3.479 c-1.15,0.074-2.309,0.117-3.482,0.082c-0.27-0.006-1.772,0.07-3.369,0.205c-2.271-0.701-4.893-0.891-6.726,0.027 c-4.837,2.422-3.072,11.467-3.112,15.523c-0.061,6.217-0.501,12.547,0.142,18.75c-0.054,0.109-0.112,0.217-0.162,0.328 c-0.229,0.523-0.013,0.988,0.356,1.192c0.063,0.465,0.113,0.93,0.19,1.392c0.121,0.73,0.221,1.461,0.324,2.18 c-0.358,0.654-0.636,1.344-0.73,2.129c-0.086,0.711,0.732,1.16,1.332,1.016c0.29,1.045,0.699,1.973,1.338,2.705 c-0.138,0.725,0.686,1.248,1.315,1.031c0.732,0.381,1.643,0.619,2.795,0.664c2.365,0.096,4.746-0.658,7.131-0.662 c4.178-0.008,8.355-0.016,12.532-0.021c0.856-0.002,1.716-0.014,2.58-0.031c0.254,0.117,0.557,0.123,0.836-0.02 c4.895-0.113,9.885-0.379,14.771-0.176c0.324,0.303,0.895,0.348,1.265,0.074c1.175,0.068,2.343,0.158,3.501,0.297 c4.832,0.584,13.352,2.34,17.698-0.998c3.668-2.816,2.514-9.275,1.479-13.154c-0.039-0.15-0.117-0.264-0.208-0.363 c1.08-1.467,1.831-3.33,2.123-5.672C73.313,51.917,74.079,37.241,68.884,39.841z M48.18,7.565c0.287-0.307,0.582-0.598,0.882-0.877 c0.111,0.068,0.223,0.137,0.333,0.205c-0.461,0.281-0.916,0.607-1.363,0.973C48.086,7.767,48.128,7.667,48.18,7.565z M52.375,12.972c0.74-0.881,1.512-1.701,2.033-2.666c2.917,2.242,5.628,4.775,7.77,7.342c0.435,0.521,1.139,0.826,1.686,1.149 c-0.255-0.15-1.619,1.82-1.782,2.016c-1.266,1.508-2.149,4.084-3.658,5.258c-0.296,0.23-0.465,0.529-0.539,0.848 c-0.494,0.002-0.992,0.014-1.486,0.02c0.11-0.117,0.226-0.232,0.334-0.352c0.481-0.531,0.793-1.279,0.488-1.963 c-0.123-0.273-0.539-0.232-0.674,0c-0.321,0.561-0.72,0.891-1.233,1.281c-0.391,0.295-0.781,0.643-1.016,1.068 c-0.719,0.017-1.437,0.035-2.153,0.051c0.002-0.017,0.01-0.035,0.01-0.053c0.479-0.525,0.941-1.072,1.405-1.607 c0.503-0.58,1.338-1.041,1.121-1.936l-0.018,0.016c-0.089-0.266-0.461-0.463-0.695-0.109c-0.133,0.205-0.688,0.367-0.899,0.504 c-0.347,0.225-0.655,0.488-0.966,0.758c-0.643,0.557-1.317,1.09-1.902,1.707c-0.23,0.242-0.29,0.51-0.257,0.756 c-0.266,0.004-0.531,0.008-0.796,0.01c-0.462,0-0.924-0.004-1.386-0.006c0.457-0.799,0.907-1.602,1.67-2.186 c0.56-0.428,0.056-1.383-0.569-0.975c-0.7,0.459-1.259,1.043-1.771,1.701c-0.354,0.453-0.735,0.943-1.062,1.455 c-1.511-0.012-3.02-0.023-4.531-0.039c1.829-2.109,3.417-4.502,5.021-6.68C48.388,17.808,50.355,15.378,52.375,12.972z M30.739,18.349c1.754-2.727,3.751-5.291,5.541-7.994c2.118-3.197,4.151-7.832,8.546-5.883c0.785,0.348,1.581,0.742,2.382,1.166 c-2.475,1.859-4.624,5.322-6.109,7.322c-0.02,0.027-0.04,0.055-0.062,0.08c-3.877,4.564-7.703,9.178-11.309,13.99 c-0.329,0.006-0.658,0.021-0.986,0.031c0.387-0.547,0.933-1.006,1.351-1.529c0.261-0.324-0.096-0.934-0.488-0.631 c-0.532,0.408-1.108,0.74-1.587,1.215c-0.199,0.197-0.545,0.59-0.741,0.99c-0.271,0.012-0.544,0.016-0.814,0.027 c-0.161,0.006-0.318,0.019-0.477,0.027c0.854-0.916,1.565-1.959,2.522-2.783c0.526-0.453-0.145-1.24-0.716-0.928 c-1.34,0.729-2.252,1.859-3.272,2.955c-0.226,0.244-0.266,0.586-0.16,0.863c-0.447,0.037-0.894,0.072-1.338,0.113 C25.678,24.374,28.688,21.54,30.739,18.349z M66.763,70.946c-0.269,0.08-0.542,0.135-0.814,0.201 c0.057-0.25,0.076-0.506,0.042-0.773c-0.069-0.527-0.857-0.742-1.003-0.135c-0.111,0.467-0.477,0.895-0.865,1.264 c-1.211,0.172-2.434,0.248-3.665,0.242c0.499-0.664,0.86-1.402,0.832-2.23c-0.019-0.578-0.967-0.764-1.056-0.143 c-0.138,0.965-1.033,1.668-1.85,2.309c-0.872-0.055-1.744-0.129-2.613-0.221c0.313-0.275,0.524-0.736,0.82-1.029 c0.42-0.414,0.88-0.781,1.293-1.205c0.729-0.75-0.37-1.828-1.141-1.141c-0.442,0.396-0.917,0.748-1.38,1.119 c-0.299,0.238-0.572,0.771-0.883,0.941c-0.411,0.225-0.852,0.6-1.241,1.029c-0.437-0.053-0.872-0.104-1.304-0.154 c-0.57-0.066-1.145-0.111-1.717-0.166c0.024-0.209,0.031-0.426-0.007-0.654c-0.109-0.676-1.098-0.58-1.269,0 c-0.053,0.178-0.157,0.35-0.275,0.52c-0.868-0.064-1.741-0.119-2.616-0.162c0.143-0.229,0.298-0.449,0.468-0.662 c0.434-0.545-0.217-1.195-0.761-0.762c-0.393,0.316-0.76,0.645-1.093,1.023c-0.084,0.1-0.166,0.201-0.244,0.305 c-0.013,0.016-0.018,0.021-0.028,0.033c-1.189-0.037-2.38-0.064-3.576-0.072c0.242-0.334,0.482-0.668,0.71-1.019 c0.341-0.527-0.335-1.205-0.863-0.863c-0.774,0.502-1.63,1.113-2.211,1.885c-1.148,0.01-2.297,0.023-3.446,0.047 c0.009-0.01,0.013-0.023,0.024-0.033c0.604-0.664-0.381-1.654-0.988-0.988c-0.215,0.236-0.361,0.49-0.527,0.758 c-0.055,0.086-0.108,0.189-0.163,0.299c-1.375,0.031-2.748,0.072-4.119,0.109c0.062-0.158,0.123-0.313,0.186-0.455 c0.308-0.701,0.815-1.484,1.262-2.107c0.355-0.498-0.391-0.979-0.803-0.619c-0.62,0.543-1.281,1.293-1.684,2.01 c-0.217,0.385-0.488,0.793-0.708,1.215c-1.339,0.037-2.678,0.072-4.006,0.094c0.202-0.34,0.371-0.693,0.453-1.08 c0.12-0.563-0.552-1.012-0.987-0.576c-0.592,0.594-1.245,1.088-1.778,1.682c-0.505,0.004-1.009,0.008-1.511,0.006 c-0.227,0-0.67,0.031-1.236,0.078c0.108-0.127,0.221-0.252,0.331-0.377c0.452-0.523,0.876-1.104,0.824-1.83 c-0.037-0.541-0.894-0.734-1.003-0.135c-0.118,0.66-0.919,0.994-1.403,1.369c-0.364,0.283-0.713,0.695-0.928,1.154 c-0.707,0.057-1.463,0.113-2.233,0.158c0.234-0.395,0.447-0.805,0.63-1.242c0.078-0.186,0.581-0.504,0.765-0.684 c0.262-0.256,0.417-0.689,0.372-1.051c-0.064-0.523-0.772-0.846-1.076-0.291c-0.107,0.195-0.543,0.381-0.729,0.5 c-0.273,0.174-0.625,0.367-0.796,0.652c-0.468,0.781-0.908,1.541-1.531,2.207c-1.066,0.014-2.045-0.02-2.792-0.139 c0.331-0.533,0.67-1.063,1.059-1.555c0.678-0.859,1.527-1.936,1.407-3.094c-0.05-0.48-0.64-0.551-0.818-0.111 c-0.21,0.518-0.869,0.949-1.252,1.346c-0.512,0.531-1.005,1.1-1.469,1.676c-0.167,0.207-0.33,0.42-0.493,0.631 c-0.419-1.211-0.724-2.516-0.942-3.865c0.269-0.426,0.524-0.84,0.727-1.229c0.548-1.047,1.048-2.137,1.776-3.08 c0.429-0.555,0.783-0.953,0.93-1.648c0.168-0.791-0.909-1.064-1.191-0.33c-0.322,0.838-1.337,1.332-1.85,2.057 c-0.267,0.379-0.515,0.771-0.758,1.17c-0.068-0.838-0.114-1.676-0.146-2.506c0.201-0.344,0.39-0.688,0.559-1.037 c0.365-0.756,0.803-1.465,1.14-2.236c0.25-0.574,0.408-1.26,0.744-1.787c0.268-0.418-0.386-0.938-0.696-0.537 c-0.662,0.855-1.212,1.84-1.817,2.77c-0.006-0.57-0.008-1.131-0.011-1.672c-0.002-0.424-0.004-0.848-0.005-1.272 c0.211-0.32,0.437-0.633,0.697-0.935c0.874-1.018,1.332-2.35,2.211-3.4c0.384-0.461-0.214-1.084-0.665-0.666 c-0.871,0.809-1.542,1.754-2.254,2.678c-0.006-1.25-0.022-2.498-0.033-3.748c0.4-0.646,0.771-1.31,1.179-1.873 c0.235-0.322-0.244-0.592-0.506-0.391c-0.243,0.188-0.47,0.389-0.688,0.594C5.68,46.7,5.68,46.3,5.674,45.897 c1.249-1.146,1.926-2.652,3.063-3.9c0.514-0.563-0.273-1.35-0.836-0.836c-0.875,0.803-1.46,1.682-2.22,2.568 c-0.016,0.02-0.034,0.033-0.05,0.051c-0.021-1.092-0.035-2.184-0.067-3.275c-0.005-0.182-0.017-0.367-0.025-0.551 c0.02-0.008,0.044-0.012,0.063-0.023c0.428-0.283,1.008-0.787,1.225-1.322c0.665-0.469,1.156-1.143,1.872-1.537 c0.85-0.467,0.093-1.76-0.759-1.299c-0.416,0.227-0.771,0.527-1.109,0.856c-0.164,0.158-0.324,0.32-0.491,0.475 c-0.214,0.199-0.505,0.299-0.708,0.5c-0.129,0.129-0.128,0.299-0.218,0.418c-0.138-1.918-0.239-3.865,0.298-5.689 c0.259-0.879,0.85-1.51,1.61-1.939c0.046,0.01,0.089,0.025,0.137,0.029c9.755,1.072,19.82-0.123,29.679-0.168 c0.285,0.104,0.604,0.117,0.9,0c0.487,0.002,0.975,0.002,1.462,0.01c5.858,0.098,11.737,0.131,17.596,0.033 c2.885-0.049,7.247-0.826,8.329,2.766c0.681,2.258,0.21,5.305,0.165,7.777c-4.262-0.5-8.772-0.484-13.005-0.244 c-3.131,0.176-5.113,1.725-6.271,4.512c-1.884,4.541-0.898,8.555-0.109,13.213c0.684,4.033,4.685,4.564,7.892,5.307 c5.375,1.244,11.098,1.07,14.854-1.775c-0.287,1.674-0.347,3.33-0.354,5.086C68.591,68.86,68.969,70.286,66.763,70.946z M69.905,53.11c-0.021,3.066-1.138,5.037-2.854,6.26c0.324-0.553,0.647-1.107,0.983-1.652c0.239-0.387-0.248-0.912-0.644-0.643 c-0.867,0.594-1.492,1.469-2.104,2.313c-0.287,0.398-0.563,0.801-0.852,1.199c-0.567,0.162-1.159,0.285-1.772,0.369 c0.149-0.125,0.293-0.258,0.432-0.391c0.511-0.482,1.033-1.014,1.365-1.637c0.165-0.307-0.188-0.565-0.43-0.42 c0-0.002,0.001-0.006,0.001-0.008c-0.465,0.248-0.86,0.588-1.293,0.889c-0.415,0.289-1.066,0.783-1.557,0.842 c-0.487,0.059-0.701,0.508-0.641,0.879c-0.735,0.01-1.481-0.016-2.222-0.074c0.337-0.385,0.645-0.793,0.951-1.168 c0.273-0.338-0.138-0.748-0.476-0.475c-0.432,0.352-0.862,0.697-1.314,1.023c-0.228,0.164-0.465,0.311-0.699,0.457 c-0.142-0.018-0.275-0.043-0.415-0.064c0.448-0.453,0.852-0.924,1.214-1.453c0.176-0.256-0.168-0.588-0.421-0.422 c-0.772,0.5-1.715,0.98-2.503,1.59c-0.417-0.078-0.833-0.158-1.227-0.246c-0.075-0.018-0.151-0.031-0.227-0.047 c0.299-0.336,0.623-0.65,0.984-0.928c0.516-0.393,0.246-1.359-0.476-1.129c-0.874,0.281-1.707,0.887-2.25,1.666 c-0.719-0.23-1.371-0.609-1.847-1.416c0.036,0.061-0.952-4.26-1.18-4.998c-0.727-2.361-0.272-7.611,2.111-9.316 c2.056-1.471,6.527-0.646,8.915-0.691c2.406-0.045,4.777-0.063,7.158-0.377c0.576,0.199,1.261,0.086,1.711-0.334 C71.846,44.378,69.927,49.812,69.905,53.11z"/>
          </g>
        </svg>
      );

    case "pdf":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
            fill="#EF4444"
          />
          <path d="M14 2V8H20" fill="#FCA5A5" />
          <text
            x="12"
            y="17.5"
            fontSize="6.5"
            fill="#FFFFFF"
            textAnchor="middle"
            fontWeight="700"
            fontFamily="Arial, sans-serif"
          >
            PDF
          </text>
        </svg>
      );

    case "membership":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L2 7L12 12L22 7L12 2Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 17L12 22L22 17"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12L12 17L22 12"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "bell":
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 21"
          fill="none"
          stroke={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 3.20312H3.83333C3.36662 3.20312 3.13327 3.20312 2.95501 3.29395C2.79821 3.37385 2.67072 3.50133 2.59083 3.65813C2.5 3.83639 2.5 4.06975 2.5 4.53646V7.70312C2.5 8.16984 2.5 8.40319 2.59083 8.58145C2.67072 8.73825 2.79821 8.86574 2.95501 8.94563C3.13327 9.03646 3.36662 9.03646 3.83333 9.03646H7C7.46671 9.03646 7.70007 9.03646 7.87833 8.94563C8.03513 8.86574 8.16261 8.73825 8.24251 8.58145C8.33333 8.40319 8.33333 8.16984 8.33333 7.70312V4.53646C8.33333 4.06975 8.33333 3.83639 8.24251 3.65813C8.16261 3.50133 8.03513 3.37385 7.87833 3.29395C7.70007 3.20312 7.46671 3.20312 7 3.20312Z"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M16.1667 3.20312H13C12.5333 3.20312 12.2999 3.20312 12.1217 3.29395C11.9649 3.37385 11.8374 3.50133 11.7575 3.65813C11.6667 3.83639 11.6667 4.06975 11.6667 4.53646V7.70312C11.6667 8.16984 11.6667 8.40319 11.7575 8.58145C11.8374 8.73825 11.9649 8.86574 12.1217 8.94563C12.2999 9.03646 12.5333 9.03646 13 9.03646H16.1667C16.6334 9.03646 16.8667 9.03646 17.045 8.94563C17.2018 8.86574 17.3293 8.73825 17.4092 8.58145C17.5 8.40319 17.5 8.16984 17.5 7.70312V4.53646C17.5 4.06975 17.5 3.83639 17.4092 3.65813C17.3293 3.50133 17.2018 3.37385 17.045 3.29395C16.8667 3.20312 16.6334 3.20312 16.1667 3.20312Z"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M16.1667 12.3698H13C12.5333 12.3698 12.2999 12.3698 12.1217 12.4606C11.9649 12.5405 11.8374 12.668 11.7575 12.8248C11.6667 13.0031 11.6667 13.2364 11.6667 13.7031V16.8698C11.6667 17.3365 11.6667 17.5699 11.7575 17.7481C11.8374 17.9049 11.9649 18.0324 12.1217 18.1123C12.2999 18.2031 12.5333 18.2031 13 18.2031H16.1667C16.6334 18.2031 16.8667 18.2031 17.045 18.1123C17.2018 18.0324 17.3293 17.9049 17.4092 17.7481C17.5 17.5699 17.5 17.3365 17.5 16.8698V13.7031C17.5 13.2364 17.5 13.0031 17.4092 12.8248C17.3293 12.668 17.2018 12.5405 17.045 12.4606C16.8667 12.3698 16.6334 12.3698 16.1667 12.3698Z"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M7 12.3698H3.83333C3.36662 12.3698 3.13327 12.3698 2.95501 12.4606C2.79821 12.5405 2.67072 12.668 2.59083 12.8248C2.5 13.0031 2.5 13.2364 2.5 13.7031V16.8698C2.5 17.3365 2.5 17.5699 2.59083 17.7481C2.67072 17.9049 2.79821 18.0324 2.95501 18.1123C3.13327 18.2031 3.36662 18.2031 3.83333 18.2031H7C7.46671 18.2031 7.70007 18.2031 7.87833 18.1123C8.03513 18.0324 8.16261 17.9049 8.24251 17.7481C8.33333 17.5699 8.33333 17.3365 8.33333 16.8698V13.7031C8.33333 13.2364 8.33333 13.0031 8.24251 12.8248C8.16261 12.668 8.03513 12.5405 7.87833 12.4606C7.70007 12.3698 7.46671 12.3698 7 12.3698Z"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
  }
};

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired, // 'name' is required
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Optional, defaults to 24
  color: PropTypes.string, // Optional, defaults to {color}
};

export default SvgIcon;
